import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomResultOfPaginatedListOfUserWithPaginationDto } from 'src/app/core/api/models';
import { PaginatedListOfUserWithPaginationDto } from '../../../../core/api/models/paginated-list-of-user-with-pagination-dto';
import { UserDto } from '../../../../core/api/models/user-dto';
import { UserWithPaginationDto } from '../../../../core/api/models/user-with-pagination-dto';
import { UsersService } from '../../../../core/api/services/users.service';
import { BaseIndexPageComponent } from '../../../shared/base/components/base-index-page.component';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseIndexModule } from 'src/app/pages/shared/base/modules/base-index.module';
import { UserAuthenticationFormComponent } from "../user-authentication-form/user-authentication-form.component";
import { UserDocumentationFormModule } from "../user-documentation-form/user-documentation-form.module";

@Component({
    selector: 'app-user-info',
    templateUrl: './user-info.component.html',
    imports: [BaseIndexModule, UserAuthenticationFormComponent, UserDocumentationFormModule]
})
export class UserInfoComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = 'users.userInfo';
  modelWithPagination$: Observable<PaginatedListOfUserWithPaginationDto>;
  items$: Observable<Array<UserWithPaginationDto>>;
  formPageConfig: FormPageConfig<UserDto> = {};

  userId;
  showUserAuthentication: boolean = false;
  showUserDocumentation: boolean = false;

  //#endregion

  constructor(protected currentService: UsersService) {
    super();
  }
  ngOnInit() {
    super.ngOnInit();
    this.pageConfig.showAuditBtn = false;
    this.pageConfig.showAddBtn = false;
    this.getUserState();
  }

  configTableColumns() {
    this.tableColumns = [
      { title: this.localizer.userName, name: 'userName', hasSearch: true },
      {
        title: this.localizer.mobile,
        name: 'mobile',
        hasSearch: true,
        dir: 'ltr',
      },
      {
        title: this.localizer.organization,
        name: 'organizationName',
        hasSearch: true,
      },
      {
        title: this.localizer.expireDate,
        name: 'expireDate',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: this.localizer.createDate,
        name: 'created',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  //#region Api

  //Get All
  getPaginationApi(): Observable<CustomResultOfPaginatedListOfUserWithPaginationDto> {
    return this.currentService.usersGetUsersWithPagination({
      body: this.getBaseModelWithPaginationParams(),
    });
  }

  //Get ById
  baseGetByIdApi(id: any): void {
    this.unSubs();

    this.pageConfig.loading = true;

    this.formPageConfig.editId = id;

    this.currentService
      .usersGetUserById({ Id: id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseGetByIdObserver);
  }

  //#endregion
  //#region User Authentication and show documentations
  onAddAuthorization(id) {
    this.showUserAuthentication = true;
  }
  onShowDocumentations(id) {
    this.showUserDocumentation = true;
    this.userId = id;
  }
  onCloseDocumentation() {
    this.showUserDocumentation = false;
  }
  onCloseAuthorization() {
    this.showUserAuthentication = false;
  }
}
